module.exports = __webpack_public_path__ + "static/kent.52a9dca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/kent.png
// module id = 2185
// module chunks = 61762850755587